import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'light' | 'dark' | 'none';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    light: 'bg-brand-light',
    dark: 'bg-brand-dark text-white',
    none: ''
  };
  return <section id={id} className={`py-20 md:py-28 px-4 md:px-8 ${bgColors[background]} ${className}`} data-id="element-184">
      <div className="max-w-7xl mx-auto w-full" data-id="element-185">{children}</div>
    </section>;
}